import { useEffect, useState } from "react";
import { questionVisible, chapterCounts, questionState, hasContent } from "@/villa142/config";

const STATE_LABELS = { empty: "Empty", draft: "Draft", reflected: "Reflected on" };

export default function ReflectionMap({ open, def, entriesMap, people, pendingSet, currentQid, onNavigate, onReview, onSaveLeave, onClose }) {
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    if (!open) return;
    const holder = (def?.chapters || []).find((ch) => ch.questions.some((q) => q.id === currentQid));
    setExpanded(holder ? holder.id : (def?.chapters?.[0]?.id ?? null));
  }, [open, currentQid, def]);

  if (!open || !def) return null;

  return (
    <div className="v142-map-backdrop" data-testid="v142-map-backdrop" onClick={onClose}>
      <aside className="v142-map" role="dialog" aria-modal="true" aria-label="Your reflections" data-testid="v142-map" onClick={(e) => e.stopPropagation()}>
        <div className="v142-map-head">
          <h2 className="v142-map-title">Your reflections</h2>
          <button type="button" className="v142-link" data-testid="v142-map-close" onClick={onClose} aria-label="Close">Close</button>
        </div>
        <div className="v142-map-body">
          {def.chapters.map((ch) => {
            const { answered, total } = chapterCounts(ch, entriesMap);
            const isOpen = expanded === ch.id;
            const visible = ch.questions.filter((q) => questionVisible(q, entriesMap));
            return (
              <div className="v142-map-chapter" key={ch.id}>
                <button
                  type="button"
                  className={`v142-map-chrow${isOpen ? " is-open" : ""}`}
                  data-testid={`v142-map-chapter-${ch.id}`}
                  aria-expanded={isOpen}
                  onClick={() => setExpanded(isOpen ? null : ch.id)}
                >
                  <span className="v142-map-chtitle">{ch.title}</span>
                  <span className="v142-map-count">{answered} of {total} reflected on</span>
                </button>
                {isOpen && (
                  <div className="v142-map-qlist">
                    {visible.map((q) => {
                      const state = questionState(q, entriesMap, pendingSet);
                      const who = people.order.filter((c) => hasContent(entriesMap[q.id]?.[c]));
                      const isCurrent = q.id === currentQid;
                      return (
                        <button
                          type="button"
                          key={q.id}
                          className={`v142-map-qrow${isCurrent ? " is-current" : ""}`}
                          data-testid={`v142-map-q-${q.id}`}
                          aria-current={isCurrent || undefined}
                          onClick={() => onNavigate(q.id)}
                        >
                          <span className="v142-map-qlabel">{q.label}</span>
                          <span className="v142-map-qmeta">
                            {who.map((c) => (
                              <span key={c} className="v142-map-initial" title={people.name(c)}>{people.initials[c]}</span>
                            ))}
                            <span className={`v142-map-state is-${state}`}>{STATE_LABELS[state]}</span>
                          </span>
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
          <button type="button" className="v142-map-chrow v142-map-reviewrow" data-testid="v142-map-review" onClick={onReview}>
            <span className="v142-map-chtitle">Review and Share</span>
            <span className="v142-map-count">The full overview</span>
          </button>
        </div>
        <div className="v142-map-foot">
          <button type="button" className="v142-link" data-testid="v142-map-save-leave" onClick={onSaveLeave}>Save and leave</button>
        </div>
      </aside>
    </div>
  );
}
